import { SkeletonContentDetail as ContentDetail } from './SkeletonContentDetail'
import { SkeletonHome as Home } from './SkeletonHome'
import { SkeletonResumedChart as ResumedChart } from './SkeletonResumedChart'
import { SkeletonTable as Table } from './SkeletonTable'
import { SkeletonWalletSummary as WalletSummary } from './SkeletonWalletSummary'

export default { ResumedChart, ContentDetail, Home, WalletSummary, Table }
